export default __webpack_public_path__ + "static/media/folderpng.53bddc27.png";